







































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import { duration } from "@/helpers";
import { capitalize } from "lodash";
import * as api from "@/lib/api";
import { collections, firestore } from "@/configs/firebase";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";

@Component({ components: { PageHeader } })
export default class OnHold extends Vue {
  loading = false;
  dialog = false;
  onHoldData: any[] = [];
  query!: firestore.Query;
  selectedDate: string = "";
  selectedDateMenu: boolean = false;

  headers = [
    {
      text: "Agent",
      sortable: true,
      value: "agent"
    },
    {
      text: "Customer Name",
      sortable: true,
      value: "customerName"
    },
    {
      text: "Customer Phone Number",
      sortable: true,
      value: "customerPhoneNumber"
    },
    {
      text: "State",
      sortable: true,
      value: "state"
    },
    {
      text: "Insured Now",
      sortable: true,
      value: "insuredNow"
    },
    {
      text: "Pre Existings",
      sortable: true,
      value: "preExistings"
    },
    {
      text: "Affordability",
      sortable: true,
      value: "affordability"
    },
    {
      text: "Important Aspects",
      value: "importantAspects"
    },
    {
      text: "Source",
      sortable: true,
      value: "source"
    },
    {
      text: "Outcome",
      sortable: true,
      value: "outcome"
    },
    {
      text: "Health Quote",
      sortable: true,
      value: "healthQuote"
    },
    {
      text: "WELL",
      value: "well",
      type: "checkbox"
    },
    {
      text: "DEN",
      value: "den",
      type: "checkbox"
    },
    {
      text: "VIS",
      value: "vis",
      type: "checkbox"
    }
  ];

  mounted() {
    this.query = collections.lead.where(
      "Qualified_Lead",
      "==",
      "Qualified Lead"
    );
    this.fetchData();
  }

  async handleDateChange(selectedDate: string) {
    this.fetchDataByDate(selectedDate);
  }

  async fetchDataByDate(date: string) {
    const startDate = firestore.Timestamp.fromDate(
      new Date(moment(date).format())
    );
    const query: firestore.Query = this.query
      .orderBy("created_ts", "desc")
      .startAt(startDate)
      .endAt(startDate);
    await this.fetchData(query);
  }

  async fetchData(query = this.query, limit = 200) {
    this.loading = true;
    try {
      const snapshot = await query.limit(limit).get();

      this.onHoldData = await Promise.all(
        snapshot.docs.map(async (item: any) => {
          const products: any = {};
          const snapshot1 = await collections.lead
            .doc(item.id)
            .collection("selected_products")
            .get();

          snapshot1.docs.forEach(doc => {
            const data = doc.data();
            products[data.type] = {
              ...data
            };
          });

          const healthQuote = products.health ? products.health.premium : "";
          const well =
            products.wellness && products.wellness.status == "sale"
              ? true
              : false;
          const den =
            products.dental && products.dental.status == "sale" ? true : false;
          const vis =
            products.vision && products.vision.status == "sale" ? true : false;

          const lead = item.data();
          return {
            agent:
              objectify(lead.assigned_agent_email_by_role).verification || "",
            customerName: `${capitalize(lead.first_name)} ${capitalize(
              lead.last_name
            )}`,
            customerPhoneNumber: lead.phone_number,
            state: lead.state_abbr,
            insuredNow: capitalize(lead.insured_now),
            preExistings: lead.pre_x_condition_details,
            affordability: lead.budget,
            importantAspects: lead.details_on_whats_important,
            source: lead.lead_source,
            outcome: lead.dial_closed_reason
              ? lead.dial_closed_reason.split(":")[1]
              : "",
            healthQuote,
            well,
            den,
            vis,
            products
          };
        })
      );
    } catch (err) {
      logger("error", "fetch data error", err);
    }
    this.loading = false;
  }

  isPostDateSale(props: any) {
    return (
      props &&
      props.item &&
      props.item.products &&
      props.item.products.health &&
      props.item.products.health.status == "sale" &&
      props.item.products.health.post_date_ts
    );
  }

  isSale(props: any) {
    return (
      props &&
      props.item &&
      props.item.products &&
      props.item.products.health &&
      props.item.products.health.status == "sale"
    );
  }

  isFailedSale(props: any) {
    return (
      props &&
      props.item &&
      props.item.products &&
      props.item.products.health &&
      props.item.products.health.status == "failed"
    );
  }
}
